var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeAttachmentSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HomeAttachment_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,3.54a5.87,5.87,0,0,0-2-1.19A6,6,0,0,0,17,2a6,6,0,0,0-6,6V22a4,4,0,0,0,2,3.44,3.85,3.85,0,0,0,4,0A4,4,0,0,0,19,22V10a1,1,0,0,0-2,0V22a2,2,0,0,1-4,0V8a4,4,0,0,1,4-4,3.91,3.91,0,0,1,2,.56A4,4,0,0,1,21,8V22a6,6,0,0,1-2,4.46,5.87,5.87,0,0,1-2,1.19,5.89,5.89,0,0,1-4,0,5.87,5.87,0,0,1-2-1.19A6,6,0,0,1,9,22V10a1,1,0,0,0-2,0V22a8,8,0,0,0,2,5.27,7.94,7.94,0,0,0,4,2.47,8,8,0,0,0,6-.82,8.16,8.16,0,0,0,2-1.65A8,8,0,0,0,23,22V8A6,6,0,0,0,21,3.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAttachmentSvg);
export default __webpack_public_path__ + "static/media/HomeAttachment_svg.ab392f6b27a5a5c4b059affe98ce5510.svg";
export { ForwardRef as ReactComponent };